import React from 'react';
import {Box} from '@mui/material';
import AccessSettings from './AccessSettings';

const ManageAccessTab = () => (
    // Maria, 19 October 2026: no heading or explanation above the table, as the tab name already says what it is
    <Box display="flex" flexDirection="column" pb={2}>
        <AccessSettings/>
    </Box>
);

export default ManageAccessTab;
